import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { FaFileExcel } from 'react-icons/fa6'
import { excelTempPrintPayrollAPI } from '../../../services/income/payroll'
import Error_false from '../../../components/error/error-false'
import { ExportExcelLip } from '../../../helper/exportExcelLip'
import { fnDateEn } from '../../../helper/fnDateEn'

export default function ButtonExportExcel({ bodyFilter }) {
  const [disabled, setDisabled] = useState(false)
  const fnExportExcel = async () => {
    try {
      setDisabled(true)
      const body = {
        orgId: bodyFilter.orgId,
        paymentPeriodDate: bodyFilter.paymentPeriodDate,
        searchs: bodyFilter.searchs ?? ''
      }
      const resp = await excelTempPrintPayrollAPI(body)
      if (!resp) return
      if (resp.status) {
        const _header = resp.result.map((d) => {
          return [
            'Code',
            'Date',
            'Name',
            'Job Level',
            'Hired Date',
            'Resigned Date',
            'Group',
            'Division',
            'Department',
            'Position',
            'Employee Type',
            'Bank Account',

            ...d.details.map((item) => item.paymentName)
          ]
        })
        const _excel = resp.result.map((d) => {
          const _detail = d.details.reduce((acc, item, index) => {
            acc[`${item.paymentName.trim()}-${index}`] = item.amounts
            return acc
          }, {})
          return {
            code: d.code,
            paymentPeriodDate: fnDateEn(d.paymentPeriodDate).format('MM/YYYY'),
            name: `${d.titleTh}${d.nameTh} ${d.surnameTh}`,
            job_level: d.jobLevel,
            hired_date: d.startDate
              ? fnDateEn(d.startDate).format('DD/MM/YYYY')
              : '',
            resigned: d.endDate ? fnDateEn(d.endDate).format('DD/MM/YYYY') : '',
            group: `${d.division_th} (${d.division})`,
            division: `${d.faction_th} (${d.faction})`,

            department: `${d.department_th} (${d.department})`,
            position: `${d.position_th} (${d.position_en})`,
            employeeType: d.type,
            bank: d.accountNo,
            ..._detail
          }
        })

        await ExportExcelLip({
          header: _header[0],
          dataExcel: _excel,
          fileName: `Payroll-Print-${fnDateEn().format('YYYYMMDDHHmmss')}`
        })
        setDisabled(false)
      }
    } catch (error) {
      Error_false(error)
    }
  }

  return (
    <Button
      size="sm"
      className="me-2"
      disabled={disabled}
      variant="success"
      onClick={() => {
        fnExportExcel()
      }}
    >
      {disabled ? '...' : <FaFileExcel />}
    </Button>
  )
}
